export default {
  sorry: 'Beklager',
  sorryClass: 'Beklager, vi kunne ikke finne ',
  weFound: 'men vi finner ',
  noResults: 'ingen resultater',
  fares: ' priser',
  theseDates: ' på disse datoene.',
  matchingSearch: 'som passer søket ditt.',
}
